import { Model } from '@vuex-orm/core';

export default class Sectionable extends Model {
  static entity = 'sectionables';

  static fields() {
    return {
      id: this.uid(),
      section_id: this.attr(null),
      sectionable_id: this.attr(null),
      sectionable_type: this.attr(null),
    };
  }
}
